/*
 * A Trator Diesel — menu de produtos do cabeçalho.
 *
 * O painel de marcas e tipos é impresso no fim do #header-group, escondido, e
 * fica lá. Ele não é movido para dentro do cabeçalho de propósito: o tema
 * redesenha a seção do cabeçalho depois do carregamento e levaria o painel
 * junto. Em vez de mexer no DOM do tema, o painel é posicionado por cima do
 * link, e os ouvintes são religados sempre que o cabeçalho é redesenhado.
 *
 *   mouse: abre ao passar o mouse no "Produtos", fecha ao sair; clicar leva
 *          para o catálogo;
 *   toque: abre no primeiro toque, o segundo toque leva para o catálogo;
 *   teclado: abre no foco, fecha no Esc.
 *
 * Sem JS o link "Produtos" continua indo para /collections/all.
 *
 * Registro 17/09 (manhã): mouse e toque separados pelo tipo do ponteiro, não
 * mais pela largura da tela.
 *
 * Registro 17/09 (tarde): relato do cliente, no navegador um pouco mais
 * estreito, "o menu desce, mostra as marcas mas não divide para os tipos,
 * nem ao passar o mouse nem ao clicar". Entre 750 e 989px o cabeçalho já
 * mostra o menu de desktop, mas o painel caía no desenho de sanfona, que só
 * abria a marca no toque: o hover de marca exigia 990px e o clique com mouse
 * seguia o link. Agora o lado a lado vale desde 750px (o painel tem até
 * 100vw menos 32px, e os tipos ficam em duas colunas abaixo de 990px), e a
 * sanfona, que só sobra abaixo de 750px, abre a marca no primeiro clique
 * também com mouse.
 */
(function () {
  'use strict';

  var LADO_A_LADO = '(min-width: 750px)';
  var ATRASO = 200;
  var INTENCAO = 130;
  var FOLGA = 10;
  var MARGEM = 16;
  var SEGUNDO_TOQUE = 500;

  var painel = null;
  var linkAtivo = null;
  var timer = null;
  var marcaTimer = null;
  var abertoEm = 0;
  var ponteiro = null;
  var marcaNoToque = null;

  /* Painel com as marcas numa coluna e os tipos ao lado. Abaixo disso,
     sanfona embaixo do cabeçalho. Só desenho, não diz nada sobre o mouse. */
  function ehDesktop() {
    return window.matchMedia(LADO_A_LADO).matches;
  }

  /* O último ponteiro que encostou na página. Antes do primeiro movimento,
     vale o que o aparelho declara. */
  function comMouse() {
    if (ponteiro) return ponteiro === 'mouse';
    return window.matchMedia('(hover: hover)').matches;
  }

  function linkDoAlvo(el) {
    if (!el || !el.closest) return null;
    return ehLinkProdutos(el.closest('.custom-nav a, .custom-nav__link'));
  }

  function ehLinkProdutos(a) {
    if (!a) return null;
    var texto = (a.textContent || '').trim().toLowerCase();
    if (texto === 'produtos') return a;
    return (a.getAttribute('href') || '').indexOf('/collections/all') > -1 ? a : null;
  }

  /*
   * Régua do painel. Algum ancestral do #header-group cria contexto de
   * posicionamento com escala, então top/left não é onde o painel aparece.
   * Medimos em duas posições conhecidas e daí sai a origem e o fator. Duas
   * leituras, nunca em laço.
   */
  function regua() {
    painel.style.left = '0px';
    painel.style.top = '0px';
    var zero = painel.getBoundingClientRect();

    painel.style.left = '100px';
    painel.style.top = '100px';
    var cem = painel.getBoundingClientRect();

    return {
      origemX: zero.left,
      origemY: zero.top,
      fatorX: (cem.left - zero.left) / 100 || 1,
      fatorY: (cem.top - zero.top) / 100 || 1
    };
  }

  /* O painel abre para a direita: a borda esquerda dele encosta na primeira
     letra de "Produtos". Só recua se não couber até a borda da tela. */
  function posicionar(link) {
    var caixa = link.getBoundingClientRect();
    var alvoTop = caixa.bottom + FOLGA;

    if (!ehDesktop()) {
      painel.style.left = '';
      painel.style.top = '0px';
      var zeroY = painel.getBoundingClientRect().top;
      painel.style.top = '100px';
      var cemY = painel.getBoundingClientRect().top;
      var fator = (cemY - zeroY) / 100 || 1;
      painel.style.top = (alvoTop - zeroY) / fator + 'px';
      return;
    }

    var r = regua();
    var largura = painel.getBoundingClientRect().width;
    var maximo = document.documentElement.clientWidth - largura - MARGEM;

    var alvoLeft = caixa.left;
    if (alvoLeft > maximo) alvoLeft = maximo;
    if (alvoLeft < MARGEM) alvoLeft = MARGEM;

    painel.style.left = (alvoLeft - r.origemX) / r.fatorX + 'px';
    painel.style.top = (alvoTop - r.origemY) / r.fatorY + 'px';
  }

  /*
   * ESCOLHA DA MARCA, COM INTENÇÃO (03/09/2026)
   *
   * Sair de uma marca de baixo e subir na diagonal até um tipo passava por
   * cima das marcas de cima e trocava o painel. A marca só troca se o mouse
   * ficar parado em cima dela por INTENCAO milissegundos, e entrar na coluna
   * dos tipos cancela a troca. Quem mostra a lista é a classe .is-ativo.
   */
  function marcas() {
    return painel ? painel.querySelectorAll('.atd-mega__marca') : [];
  }

  function ativarMarca(li) {
    if (!li || li.classList.contains('is-ativo')) return;
    var lista = marcas();
    for (var i = 0; i < lista.length; i++) lista[i].classList.remove('is-ativo');
    li.classList.add('is-ativo');
    medirCorpo();
  }

  /* A ALTURA DO MENU SEGUE A MARCA, 23/09/2026.

     A coluna da direita é posicionada em absoluto, com `top: 0; bottom: 0`:
     ela não empurra o corpo do menu, então o corpo vivia numa altura fixa de
     440px. Isso servia enquanto cada marca mostrava no máximo 12 tipos. Com
     os tipos em ordem alfabética o corte de 12 teve de sair (em A-Z ele
     esconderia justamente Filtro, Juntas, Pistão e Virabrequim), e a Yanmar
     passou a mostrar os 24 que tem: passava de 440 e ganhava barra de
     rolagem, enquanto a Tramontini, com um tipo só, deixava 400px de vão.

     Então o corpo passa a receber a altura da marca ativa. Some a barra de
     rolagem e some o vão. Medir com o menu fechado não serve: o painel está
     em `display: none` e devolve zero. Por isso a medida também é refeita ao
     abrir. */
  function medirCorpo() {
    if (!painel || !painel.classList.contains('is-aberto')) return;

    var corpo = painel.querySelector('.atd-mega__corpo');
    var coluna = painel.querySelector('.atd-mega__coluna');
    if (!corpo || !coluna) return;

    /* No celular o menu é sanfona: cada marca abre embaixo da outra e a
       altura é a do próprio conteúdo. Medida nenhuma a fazer. */
    if (!ehDesktop()) {
      corpo.style.minHeight = '';
      return;
    }

    var li = painel.querySelector('.atd-mega__marca.is-ativo') ||
      painel.querySelector('.atd-mega__marca');
    var tipos = li ? li.querySelector('.atd-mega__tipos') : null;
    if (!tipos) return;

    /* Zera antes de medir: com a altura anterior no lugar, `scrollHeight`
       devolve a caixa, não o conteúdo, e o menu nunca voltaria a encolher. */
    corpo.style.minHeight = '';
    var alvo = Math.max(coluna.offsetHeight, tipos.scrollHeight);

    /* Teto da tela. Medido a 1440x700: a Yanmar pede 621px e o menu começa
       em 172px, ou seja, 96px dele ficariam abaixo da borda da janela, fora
       do alcance. Quando não cabe, o menu para na borda e a coluna da
       direita volta a rolar, que é o mal menor. O piso de 360px existe para
       janela muito baixa não espremer o menu até virar um risco. */
    var topo = painel.getBoundingClientRect().top;
    var cabe = window.innerHeight - topo - 16;
    if (cabe > 360 && alvo > cabe) alvo = cabe;

    corpo.style.minHeight = alvo + 'px';
  }

  function voltarParaPrimeira() {
    var lista = marcas();
    if (lista.length) ativarMarca(lista[0]);
  }

  function ligarMarcas() {
    var lista = marcas();

    for (var i = 0; i < lista.length; i++) {
      (function (li) {
        if (li.dataset.atdMarcaLigada === '1') return;
        li.dataset.atdMarcaLigada = '1';

        var link = li.querySelector('.atd-mega__marca-link');
        var tipos = li.querySelector('.atd-mega__tipos');
        if (!link) return;

        link.addEventListener('mouseenter', function () {
          if (!ehDesktop() || !comMouse()) return;
          clearTimeout(marcaTimer);
          marcaTimer = setTimeout(function () {
            ativarMarca(li);
          }, INTENCAO);
        });

        link.addEventListener('mouseleave', function () {
          clearTimeout(marcaTimer);
        });

        link.addEventListener('focus', function () {
          clearTimeout(marcaTimer);
          ativarMarca(li);
        });

        if (tipos) {
          tipos.addEventListener('mouseenter', function () {
            clearTimeout(marcaTimer);
          });
        }
      })(lista[i]);
    }
  }

  function abrir(link) {
    clearTimeout(timer);
    if (!painel) return;

    if (!estaAberto() || linkAtivo !== link) abertoEm = Date.now();
    if (linkAtivo && linkAtivo !== link) linkAtivo.classList.remove('atd-mega-ativo');
    linkAtivo = link;
    link.classList.add('atd-mega-ativo');
    link.setAttribute('aria-expanded', 'true');

    painel.removeAttribute('hidden');
    painel.classList.add('is-aberto');
    posicionar(link);
    medirCorpo();
  }

  function fechar() {
    clearTimeout(timer);
    clearTimeout(marcaTimer);
    if (!painel) return;

    painel.classList.remove('is-aberto');
    var abertas = painel.querySelectorAll('.atd-mega__marca.is-aberto');
    for (var i = 0; i < abertas.length; i++) abertas[i].classList.remove('is-aberto');

    voltarParaPrimeira();

    if (linkAtivo) {
      linkAtivo.classList.remove('atd-mega-ativo');
      linkAtivo.setAttribute('aria-expanded', 'false');
    }
  }

  function fecharDepois() {
    clearTimeout(timer);
    timer = setTimeout(fechar, ATRASO);
  }

  function estaAberto() {
    return painel && painel.classList.contains('is-aberto');
  }

  function ligarLinks() {
    var links = document.querySelectorAll('#header-group .custom-nav a, #header-group .custom-nav__link');

    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (link.dataset.atdLigado === '1') continue;
      if (!ehLinkProdutos(link)) continue;

      link.dataset.atdLigado = '1';
      link.setAttribute('aria-expanded', 'false');
      link.setAttribute('aria-haspopup', 'true');

      (function (a) {
        a.addEventListener('mouseenter', function () {
          if (comMouse()) abrir(a);
        });

        a.addEventListener('mouseleave', function () {
          if (comMouse()) fecharDepois();
        });

        a.addEventListener('focus', function () {
          abrir(a);
        });

        /* Mouse: o painel já abriu no hover, o clique vai para o catálogo.
           Toque: o foco do próprio toque abre o painel um instante antes do
           clique, então "já aberto" só conta como segundo toque se abriu há
           mais de SEGUNDO_TOQUE. */
        a.addEventListener('click', function (e) {
          if (comMouse()) return;
          if (estaAberto() && Date.now() - abertoEm > SEGUNDO_TOQUE) return;
          e.preventDefault();
          abrir(a);
        });
      })(link);
    }
  }

  function iniciar() {
    painel = document.querySelector('[data-atd-mega]');
    if (!painel || painel.dataset.pronto === '1') return;
    painel.dataset.pronto = '1';
    painel.removeAttribute('hidden');

    document.addEventListener('pointerover', function (e) {
      if (e.pointerType) ponteiro = e.pointerType;
    }, true);
    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType) ponteiro = e.pointerType;
      var li = e.target && e.target.closest ? e.target.closest('.atd-mega__marca') : null;
      marcaNoToque = li && li.classList.contains('is-ativo') ? li : null;
    }, true);

    ligarLinks();
    ligarMarcas();
    voltarParaPrimeira();

    /* O tema redesenha a seção do cabeçalho depois do carregamento, o que
       apaga os ouvintes dos links. Religamos quando isso acontece, e ainda
       tentamos de novo por alguns segundos. */
    if (window.MutationObserver) {
      var alvo = document.getElementById('header-group');
      if (alvo) {
        new MutationObserver(function () {
          ligarLinks();
          ligarMarcas();
        }).observe(alvo, { childList: true, subtree: true });
      }
    }
    document.addEventListener('shopify:section:load', ligarLinks);

    var tentativas = 0;
    var relogio = setInterval(function () {
      ligarLinks();
      if (++tentativas > 30) clearInterval(relogio);
    }, 300);

    document.addEventListener('mouseover', function (e) {
      if (!comMouse()) return;

      var link = linkDoAlvo(e.target);
      if (link) {
        abrir(link);
        return;
      }
      if (painel.contains(e.target)) {
        clearTimeout(timer);
        return;
      }
      if (estaAberto()) fecharDepois();
    });

    painel.addEventListener('mouseenter', function () {
      clearTimeout(timer);
    });

    painel.addEventListener('mouseleave', function () {
      clearTimeout(marcaTimer);
      if (comMouse()) fecharDepois();
    });

    painel.addEventListener('focusout', function (e) {
      if (!painel.contains(e.relatedTarget) && e.relatedTarget !== linkAtivo) fechar();
    });

    /* Clique numa marca dentro do painel.
       Lado a lado: com mouse o hover já escolheu, o clique segue o link;
       com toque, o primeiro toque ativa a coluna e o segundo vai para a
       coleção.
       Sanfona (abaixo de 750px): o primeiro clique abre a gaveta da marca,
       com mouse ou com toque; o segundo vai para a coleção. */
    painel.addEventListener('click', function (e) {
      var marca = e.target.closest ? e.target.closest('.atd-mega__marca-link') : null;
      if (!marca) return;

      var li = marca.closest('.atd-mega__marca');
      if (!li) return;

      if (ehDesktop()) {
        if (comMouse()) return;
        if (li === marcaNoToque) return;
        e.preventDefault();
        ativarMarca(li);
        marcaNoToque = li;
        return;
      }

      if (li.classList.contains('is-aberto')) return;

      e.preventDefault();
      var irmas = painel.querySelectorAll('.atd-mega__marca');
      for (var i = 0; i < irmas.length; i++) irmas[i].classList.remove('is-aberto');
      li.classList.add('is-aberto');
    });

    document.addEventListener('click', function (e) {
      if (!estaAberto()) return;
      if (painel.contains(e.target)) return;
      if (linkAtivo && linkAtivo.contains(e.target)) return;
      fechar();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && estaAberto()) {
        var alvo = linkAtivo;
        fechar();
        if (alvo) alvo.focus();
      }
    });

    window.addEventListener('resize', function () {
      if (estaAberto() && linkAtivo) {
        posicionar(linkAtivo);
        medirCorpo();
      }
    });

    window.addEventListener(
      'scroll',
      function () {
        if (estaAberto() && linkAtivo) posicionar(linkAtivo);
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
